import { useState } from "react";
import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight, RotateCcw, Crosshair } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../lib/api";

const STEP = 0.25;

// Allineamento manuale foto satellitare (offset in metri: dx = est, dy = nord), salvato in roof.sat_offset.
export function useSatOffset(roof) {
  const init = { dx: Number(roof?.sat_offset?.dx) || 0, dy: Number(roof?.sat_offset?.dy) || 0 };
  const [off, setOff] = useState(init);
  const dirty = off.dx !== init.dx || off.dy !== init.dy;
  const nudge = (ddx, ddy) => setOff((o) => ({ dx: +(o.dx + ddx).toFixed(2), dy: +(o.dy + ddy).toFixed(2) }));
  const reset = () => setOff({ dx: 0, dy: 0 });
  const persist = async (base) => {
    if (!dirty) return;
    await api.put(`${base}/roof/sat-offset`, off);
    if (roof) roof.sat_offset = { ...off };
  };
  return { off, nudge, reset, persist, dirty };
}

export function SatAlignControls({ s, prefix }) {
  const [open, setOpen] = useState(false);
  const b = (icon, onClick, id, title) => (
    <Button size="icon" variant="outline" className="h-7 w-7" onClick={onClick} data-testid={`${prefix}-sat-${id}`} title={title}>{icon}</Button>
  );
  return (
    <div className="flex items-center gap-1">
      <Button size="sm" variant={open ? "default" : "outline"} onClick={() => setOpen((v) => !v)} data-testid={`${prefix}-sat-align-toggle`}
        title="Allinea la foto satellitare al disegno (se la foto risulta sfalsata)">
        <Crosshair className="h-4 w-4 mr-1" strokeWidth={1.5} />Allinea foto
      </Button>
      {open && (
        <>
          {b(<ArrowLeft className="h-3.5 w-3.5" />, () => s.nudge(-STEP, 0), "left", "Foto a ovest 25 cm")}
          {b(<ArrowUp className="h-3.5 w-3.5" />, () => s.nudge(0, STEP), "up", "Foto a nord 25 cm")}
          {b(<ArrowDown className="h-3.5 w-3.5" />, () => s.nudge(0, -STEP), "down", "Foto a sud 25 cm")}
          {b(<ArrowRight className="h-3.5 w-3.5" />, () => s.nudge(STEP, 0), "right", "Foto a est 25 cm")}
          {b(<RotateCcw className="h-3.5 w-3.5" />, s.reset, "reset", "Azzera allineamento")}
          <span className="text-[11px] text-muted-foreground tabular-nums" data-testid={`${prefix}-sat-offset-value`}>
            E {s.off.dx.toFixed(2)} m · N {s.off.dy.toFixed(2)} m
          </span>
        </>
      )}
    </div>
  );
}

export function SatImage({ geo, off }) {
  const ppm = geo.W / geo.spanX;
  return <image href={geo.satUrl} x={off.dx * ppm} y={-off.dy * ppm} width={geo.W} height={geo.H} preserveAspectRatio="none" data-testid="editor-sat-bg" />;
}
